import { Button, PageHeader } from 'components';
import { Form, Row, Col, Typography, Divider } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useRequests from '../useRequests';
import FormHelper from 'helpers/FormHelper';
import NotificationFormForEdit from 'components/modules/notificationFormForEdit';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    handleCreateOrUpdate,
    shops,
    inactiveShops,
    titleTypes,
    singleItem,
    handleDeleteFile,
    updateInProcess,
    handleApprove,
  } = useRequests(false, !isNew);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('CREARE APERTURE/CHIUSURE') : t('MODIFICA ANNUNCIO');
  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Row>
          <Col>
            <Typography.Title level={3}>
              {t(
                'LE RICHIESTE DI APERTURA/CHIUSURA COMMERCIALE DEVONO ESSERE TRASMESSE CON 48 ORE DI ANTICIPO, SALVO EMERGENZE IMPREVEDIBILI',
              )}
            </Typography.Title>
          </Col>
        </Row>
        <Divider />
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            company_id: '',
            type_event: '',
            date_from: '',
            time_from: '',
            date_to: '',
            time_to: '',
            docs: [],
            work_description: '',
            staff: '',
            staff_phone: '',
            external_personal_access: false,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout={'vertical'}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection
            isView={isApproveOnly}
            shops={shops}
            inactiveShops={inactiveShops}
            titleTypes={titleTypes}
            isEdit={!isNew}
            docs={singleItem?.docs || []}
            handleDeleteFile={handleDeleteFile}
            updateInProcess={updateInProcess}
          />
          {!isApproveOnly && (
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={onClickSave}
                  width={'150px'}
                  big
                  icon={<CheckOutlined />}
                  loading={updateInProcess}
                >
                  {t('Invia')}
                </Button>
              </Col>
            </Row>
          )}
          {!isNew && (
            <NotificationFormForEdit
              status={'singleItem.status'}
              dontBlockApprove
              loading={updateInProcess}
              handleOnFinish={handleApprove}
              showApprove={!!singleItem.can_approve}
              showReject={!!singleItem.can_reject}
              showToAdim={!!singleItem.can_to_admin}
              showRefuse={!!singleItem.can_refuse}
            />
          )}
        </Form>
      </div>
    </div>
  );
};

export default Edit;
